export const DEFAULT_LOCAL_API_URL_ROOT = 'http://127.0.0.1:3002/api/';

const getRuntimeHostname = () => {
  if (typeof window === 'undefined') return '';
  return window.location.hostname;
};

export const isLocalHostname = (hostname = '') =>
  hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';

export const resolveApiUrlRoot = (configuredUrl = '', hostname = getRuntimeHostname()) => {
  const normalizedUrl = `${configuredUrl || ''}`.trim();

  if (isLocalHostname(hostname) && (!normalizedUrl || normalizedUrl.includes('blackwind.vn'))) {
    return DEFAULT_LOCAL_API_URL_ROOT;
  }

  return normalizedUrl || '/api/';
};
